import type { ButtonProps } from '../../Button';

import { useTranslation } from 'react-i18next';

import { CloseIcon } from '../../../../images/shapes';

import Button from '../../Button';

interface CancelButtonProps extends ButtonProps {
  /**
   * Button label, default "Cancel"
   */
  label?: string;
}

const CancelButton = ({ label = '', ...props }: CancelButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      buttonColor="blueBordered"
      iconPosition="start"
      iconImage={<CloseIcon className="w-3 min-w-3" />}
      {...props}
    >
      {label || t('Global.Cancel')}
    </Button>
  );
};

export default CancelButton;
